import { scenes } from "@/mocks/homeData";

export default function SceneSection() {
  return (
    <section id="scenes" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-label tracking-[0.2em] text-primary-600 uppercase">
            Use Cases
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            适合这些日常场景
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            影视、小说、漫画与听书各有节奏，把内容放进一天里的不同片段，随时都能找到合适的一种。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {scenes.map((s, idx) => (
            <article
              key={s.title}
              className={`rounded-lg border p-5 md:p-6 transition-colors ${
                idx % 3 === 1
                  ? "border-secondary-200 bg-secondary-50"
                  : "border-background-200 bg-background-100"
              }`}
            >
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 rounded-lg bg-background-50 border border-background-200 text-primary-600 flex items-center justify-center text-xl shrink-0">
                  <i className={s.icon} aria-hidden="true"></i>
                </span>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                  {s.title}
                </h3>
              </div>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}